// The page's CSRF token (from csrf_meta_tags), for fetch requests that change
// something: Rails refuses a POST without it.
export function csrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.content
}
